import { trackEventAsync, generateRequiredProperties } from './index';

export const generateUIProperties = () => ({
  ...generateRequiredProperties(),
  eventVersion: 3,
  eventName: 'UI Action Performed',
});

export default {
  trackDateRangeChangeEvent: (
    tab: string,
    button: string,
    from: string,
    to: string,
  ): Promise<void> =>
    trackEventAsync({
      ...generateUIProperties(),
      eventProperties: {
        name: 'Date Range Change',
        data: {
          tab,
          button,
          from,
          to,
        },
      },
    }),
  trackSelectPrescription: (prescriptionId: string): Promise<void> =>
    trackEventAsync({
      ...generateUIProperties(),
      eventProperties: {
        name: 'Prescription Selected',
        data: {
          prescriptionId,
        },
      },
    }),
  trackDownloadDocumentEvent: (type: string): Promise<void> =>
    trackEventAsync({
      ...generateUIProperties(),
      eventProperties: {
        name: 'Download Document',
        data: { document: type },
      },
    }),
  trackChangeMonthOnCalendarTabEvent: (
    direction: string,
    viewMonth: string,
  ): Promise<void> =>
    trackEventAsync({
      ...generateUIProperties(),
      eventProperties: {
        name: 'Change Month on Calendar Tab',
        data: {
          direction,
          view_month: viewMonth,
        },
      },
    }),
};
